import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/Loader";
import BookingJourneySelector from "./BookingJourneySelector";
import CorporateBookingForm from "../new-booking-form/CorporateBookingForm";
import {
  getApplicantDetails,
  getOppprtunityDetails,
  setKycVerificationActiveStep,
} from "../new-booking-form/new-booking-form.slice";
import { BOOKING_AS } from "../../config/constant";
import {
  setIsCorporateFlow,
  setEntity,
  getMasterDataList,
  setResetData,
  setApplicantTotal,
  setActiveStep,
  setIsFromPreview,
  setProjectBrandImage,
  setIsLoading,
  setEditPreviewApplicant,
} from "../new-booking-form/new-booking-form.slice";
import { GET } from "../../services/axiosInstance";

import { useTranslation } from "react-i18next";
import { route } from "../../services/apiRoutes";
import { BOOKING_FORM_STATUS } from "../../config/constant";
import IndividualCustomerForm from "../new-booking-form/IndividualCustomerForm";
import { useHandleRedirection } from "../new-booking-form/hooks/useHandleRedirection";

const BookingHandler = () => {
  const { oppId } = useParams();
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const {
    entity,
    isFromPreview,
    enquiryDetails,
    isLoading,
    applicantData,
    applicantEditPreview,
  } = useSelector((state) => state.newBookingForm);

  const [step, setStep] = useState("select");
  const [bookingAs, setBookingAs] = useState("");
  const [selectedJourney, setSelectedJourney] = useState("");
  const history = useHistory();
  const { handleRedirection } = useHandleRedirection();

  useEffect(() => {
    if (applicantData?.opportunityId !== oppId) {
      dispatch(setResetData());
    }
  }, []);

  useEffect(() => {
    dispatch(getOppprtunityDetails(`/${oppId}`))
      .unwrap()
      .then((res) => {
        if (res) {
          dispatch(setKycVerificationActiveStep(0));
          getTermsAndCondition(res?.data);
          dispatch(getMasterDataList());

          dispatch(getApplicantDetails(`/${oppId}`))
            .unwrap()
            .then((res) => {
              if (!res?.isAgreedOnTerms) {
                dispatch(setEditPreviewApplicant(false));
              }
              if (res?.bookingAs) {
                setBookingAs(res?.bookingAs);
                setStep("form");
                dispatch(
                  setIsCorporateFlow(res?.bookingAs === BOOKING_AS.CORPORATE)
                );
                dispatch(
                  setEntity(
                    res?.bookingAs === BOOKING_AS.PARTNERSHIP_FIRM
                      ? t("entity.firm")
                      : t("entity.company")
                  )
                );
              } else {
                //dispatch(getApplicantDetails(`/${oppId}`));
              }
              if (res) {
                handleRedirection(
                  res,
                );
              }
              if (res?.signedPdf === null) {
                if (
                  res?.leegalityData?.isSignLater === true ||
                  applicantData?.bookingFormStatus ===
                  BOOKING_FORM_STATUS?.PARTIALLY_SIGNED ||
                  applicantData?.bookingFormStatus ===
                  BOOKING_FORM_STATUS?.NOT_SIGNED ||
                  applicantData?.bookingFormStatus ===
                  BOOKING_FORM_STATUS?.SIGNED_OFFLINE
                ) {
                  //history.push(`/customer-preview/${oppId}`);
                } else {
                  dispatch(setApplicantTotal(res?.noOfApplicants));
                  if (!isFromPreview?.value) {
                    dispatch(setActiveStep(res?.lastStep || 0));
                  } else {
                    dispatch(setActiveStep(isFromPreview?.index || 0));
                    dispatch(setIsFromPreview({ value: false, index: null }));
                  }
                }
              }
              if (res?.signedPdf !== null) {
                dispatch(setActiveStep(0));
                //history.push(`/thank-you/${oppId}`);
              }
            })
            .catch((error) => {
              setBookingAs("");
              setStep("select");
              dispatch(setResetData());

              console.error("Failed to Fetch applicant details", error);
            });
        }
      })
      .catch((error) => {
        console.error("Failed to Fetch opportunity details", error);
        history.push("/404");
      });
  }, []);

  const getTermsAndCondition = async (data) => {
    try {
      const res = await GET(
        route.GET_TERMS_AND_CONDITION,
        `/${data?.ProjectName}/${data?.projectBrandName}`
      );
      if (res?.response?.success) {
        let imageUrl = res?.response?.response?.data?.brandLogo || "";
        dispatch(setProjectBrandImage(imageUrl));
        dispatch(setIsLoading(false));
      }
    } catch (error) {
      dispatch(setProjectBrandImage(""));
      console.log("error", error);
    }
  };
  const handleJourneySelect = (journey) => {
    // Call the get-booking API again to get updated bookingAs if needed
    setSelectedJourney(journey);
  };

  useEffect(() => {
    if (applicantData?.bookingAs && step === "select") {
      setBookingAs(applicantData?.bookingAs);
      setStep("form");
    }
  }, [applicantData?.bookingAs, step]);

  useEffect(() => {
    if (selectedJourney) {
      setStep(selectedJourney);
      setBookingAs(selectedJourney);
      if (selectedJourney === BOOKING_AS.CORPORATE) {
        dispatch(setIsCorporateFlow(true));
        dispatch(setEntity(t("entity.company")));
      }
      if (selectedJourney === BOOKING_AS.PARTNERSHIP_FIRM) {
        dispatch(setIsCorporateFlow(false));
        dispatch(setEntity(t("entity.firm")));
      }
    }
  }, [selectedJourney]);
  if (isLoading && step === "select") {
    return <Loader isLoading={isLoading} />;
  }

  if (step === "select") {
    return <BookingJourneySelector onContinue={handleJourneySelect} />;
  } else {
    if (bookingAs === BOOKING_AS.INDIVIDUAL) {
      return <IndividualCustomerForm />;
    } else {
      return <CorporateBookingForm />;
    }
  }
};

export default BookingHandler;
